<template>
  <div class="pos-controls">
    <!-- Snapshot Card -->
    <div class="snapshot-container" v-if="isOpenShift">
      <div class="snapshot-card" v-if="hasSnapshotData">
        <div class="card-body">
          <p class="snapshot-code">{{ snapshotData.code }}</p>
          <img
            class="snapshot-img"
            :src="snapshotData.thumbnail ? snapshotData.thumbnail : noImage"
            :alt="snapshotData.name"
          />
          <p class="snapshot-name-price">
            {{ snapshotData.name }} - {{ snapshotData.price | currency }}
          </p>
        </div>
      </div>
      <div class="snapshot-card" v-else>
        <div class="card-body">
          <p class="snapshot-code code-kosong">Belum Ada Barang</p>
        </div>
      </div>
    </div>

    <!-- Control Buttons -->
    <div class="controls-container">
      <!-- Catalog Button -->
      <div class="p-col" v-if="isOpenShift">
        <Button
          @click="$emit('open-catalog')"
          v-shortkey.push="['shift', 'k']"
          @shortkey="$emit('open-catalog')"
          icon="pi pi-file"
          label="Katalog"
          class="p-button-outlined"
          style="height: 40px"
        />
      </div>

      <!-- Gift Button -->
      <div class="p-col" v-if="isOpenShift">
        <Button
          icon="pi pi-heart"
          label="Hadiah"
          class="p-button-outlined"
          style="height: 40px"
          @click="$emit('open-gift')"
          v-shortkey.push="['f9']"
          @shortkey="$emit('open-gift')"
        />
      </div>

      <!-- Pending Transactions Button -->
      <div class="p-col" v-if="isOpenShift">
        <Button
          @click="$emit('open-pending')"
          v-shortkey.push="['shift', 'p']"
          @shortkey="$emit('open-pending')"
          icon="pi pi-shopping-cart"
          label="Tertunda"
          class="p-button-outlined"
          style="height: 40px"
        />
      </div>

      <!-- Refund Button -->
      <div class="p-col" v-if="isOpenShift">
        <Button
          icon="pi pi-dollar"
          label="Refund"
          class="p-button-outlined"
          style="height: 40px"
          @click="$emit('open-refund')"
          v-shortkey.push="['home']"
          @shortkey="$emit('open-refund')"
        />
      </div>

      <!-- Receipt Button -->
      <div class="p-col" v-if="isOpenShift">
        <Button
          icon="pi pi-print"
          label="Struk"
          class="p-button-outlined"
          style="height: 40px"
          @click="$emit('open-receipt')"
          v-shortkey.push="['end']"
          @shortkey="$emit('open-receipt')"
          :loading="loadingReceipt"
          :disabled="loadingReceipt"
        />
      </div>

      <!-- History Button -->
      <div class="p-col" v-if="isOpenShift">
        <Button
          icon="pi pi-list"
          label="Riwayat"
          class="p-button-outlined"
          style="height: 40px"
          @click="$emit('open-history')"
          v-shortkey.push="['shift', 'h']"
          @shortkey="$emit('open-history')"
        />
      </div>

      <!-- Summary Button -->
      <div class="p-col" v-if="isOpenShift">
        <Button
          icon="pi pi-chart-bar"
          label="Ringkasan"
          class="p-button-outlined"
          style="height: 40px"
          @click="$emit('open-summary')"
          v-shortkey.push="['shift', 'm']"
          @shortkey="$emit('open-summary')"
        />
      </div>

      <!-- Logout Button -->
      <div class="p-col">
        <Button
          @click="$emit('logout')"
          icon="pi pi-sign-out"
          label="Logout"
          class="p-button-outlined"
          style="height: 40px"
        />
      </div>
    </div>
  </div>
</template>

<script>
import noImage from '@/assets/images/no-image.png'

export default {
  name: 'POSControls',
  props: {
    isOpenShift: {
      type: Boolean,
      default: false
    },
    snapshot: {
      type: [Object, Array],
      default: () => ({
        code: '',
        name: '',
        price: 0,
        thumbnail: null
      })
    },
    loadingReceipt: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      noImage
    }
  },
  computed: {
    snapshotData() {
      if (Array.isArray(this.snapshot)) {
        return this.snapshot.length > 0 ? this.snapshot[0] : {}
      }
      return this.snapshot || {}
    },
    hasSnapshotData() {
      return this.snapshotData && this.snapshotData.code
    }
  }
}
</script>

<style scoped lang="scss">
.pos-controls {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /* Snapshot Container */
  .snapshot-container {
    flex: 0 0 auto;
    height: 20vh;
    padding: 0.25rem;
    overflow: hidden;
  }

  .snapshot-code {
    font-weight: 700;
    font-size: 14px;
    word-wrap: break-word;
    text-align: center;
    padding: 2px 8px 0px 8px;
    margin-bottom: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .code-kosong {
    padding: 25px 0px;
  }

  .snapshot-card {
    height: 100%;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    border-radius: 0.25rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0.25rem;
    overflow: hidden;
  }

  .snapshot-name-price {
    font-size: 10px;
    font-weight: 500;
    word-wrap: break-word;
    text-align: center;
    margin: 2px 8px 0px 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 1.1;
  }

  .snapshot-img {
    max-width: 100% !important;
    padding: 0px;
    height: 10vh;
    display: block;
    margin: auto;
    object-fit: contain;
  }

  /* Controls Container */
  .controls-container {
    flex: 1;
    padding: 0.75rem 0.5rem;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  /* Control Buttons Layout */
  .p-col {
    display: flex;
    justify-content: center;
    margin-bottom: 0;
    padding: 0;
  }

  .p-col .p-button {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }
}
</style>
